module.exports = __webpack_public_path__ + "img/web_icon_play@2x.ba12531c.png";